import React from "react";
import PropTypes from "prop-types";

const LibraAmount = ({ amount, scale = true }) => {
  const formatAmount = (value) => {
    let scaled = scale ? value / 1000000 : value;
    return `${scaled.toLocaleString("en-US", {
      maximumFractionDigits: 0,
    })}`;
  };

  return <span>{formatAmount(amount)}</span>;
};

LibraAmount.propTypes = {
  amount: PropTypes.number.isRequired,
};

export default LibraAmount;
